/* eslint-disable max-len */
// Dependencies
import React, {useState, useEffect, useRef} from 'react'
import {connect} from 'react-redux'

import Helpers from '../Helpers.js'
import {storePayload} from '../actions/storePayload'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesTaskView from '../styles/TaskView.module.css'
import {Icon} from '@lazarusai/forms-ui-components'
import TaskDetails from './TaskDetails'
import ProcessOutput from './ProcessOutput'

// Components

function TaskView({
  moduleKey,
  ...props
}) {
  const [activeTab, setActiveTab] = useState('details')
  const [task, setTask] = useState({})
  const [taskFiles, _setTaskFiles] = useState({})
  const taskFilesRef = useRef({})
  const [areFilesLoading, setAreFilesLoading] = useState(false)

  function setTaskFiles(val) {
    taskFilesRef.current = val
    _setTaskFiles(val)
  }

  useEffect(() => {
    const newTask = props.modules?.[moduleKey]?.tasks?.[props.taskId]
    if (newTask) {
      setTask(structuredClone(newTask))
      if (Object.keys(taskFilesRef.current)?.length === 0) {
        // prevent constant reloading of the files
        const storedFiles = props.moduleFiles?.[moduleKey]?.[props.taskId]
        if (storedFiles) {
          setTaskFiles(storedFiles)
        } else {
          updateTaskFiles(newTask)
        }
      }
    }
  }, [props.modules, props.taskId, moduleKey])

  async function updateTaskFiles(newTask) {
    if (newTask?.sources?.length) {
      setAreFilesLoading(true)
      const newFiles = {}
      const files = newTask?.sources
      for (let fIndex = 0; fIndex < files.length; fIndex++) {
        const fileObj = structuredClone(files[fIndex])
        if (files[fIndex]?.type !== 'url') {
          const file = await Helpers.getFileFromURL(files[fIndex]?.url, files[fIndex]?.name)
          fileObj.file = file
        }
        const fileKey = files[fIndex]?.type !== 'url' ? fileObj?.file?.name : files[fIndex]?.url
        newFiles[fileKey] = fileObj
      }
      setTaskFiles(newFiles)
      const newModuleFiles = props.moduleFiles || {}
      if (newModuleFiles[moduleKey]) {
        newModuleFiles[moduleKey][props.taskId] = newFiles
      } else {
        newModuleFiles[moduleKey] = {
          [props.taskId]: newFiles,
        }
      }
      props.storePayload({
        moduleFiles: newModuleFiles,
      })
      setAreFilesLoading(false)
    }
  }

  const tabs = {
    'details': 'Task Details',
    'logs': 'Step Breakdown',
  }

  return (
    <>
      <div
        className={stylesTaskView['task-view-back-row']}
        onClick={() => {
          props.storePayload({
            taskId: null,
          })
        }}
      >
        <Icon
          icon={'arrow-ios-back-outline'}
          className={stylesTaskView['task-view-back-row-icon']}
        />
        <div
          className={stylesTaskView['task-view-back-row-text']}
        >
          Back
        </div>
      </div>
      <div
        className={stylesTaskView['task-view-title']}
      >
        {task?.name || 'NAME'}
      </div>
      <div
        className={stylesTaskView['task-view-tabs']}
        key={`${areFilesLoading}-loading-files-tabs`}
      >
        {Object.keys(tabs).map((tabKey) => {
          const disabledTab = tabKey === 'logs' && areFilesLoading
          return (
            <div
              key={`${tabKey}-tab`}
              className={`${stylesTaskView['tab']} ${tabKey === activeTab ? stylesTaskView['active-tab'] : ''} ${disabledTab ? stylesTaskView['disabled-tab'] : ''}`}
              onClick={() => {
                setActiveTab(tabKey)
              }}
            >
              {tabs[tabKey]}
            </div>
          )
        })}
      </div>
      {activeTab === 'details' ?
        <>
          <TaskDetails
            task={task}
            taskFiles={taskFiles}
            areFilesLoading={areFilesLoading}
          />
        </> :
        <div
          className={stylesTaskView['task-view-process-wrapper']}
        >
          <ProcessOutput
            stepBackgroundColor={'#1a1a1a'}
            task={task}
            taskFiles={taskFiles}
          />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  currentTasks: state.userReducer.currentTasks,
  taskId: state.userReducer.taskId,
  modules: state.userReducer.modules,
  moduleFiles: state.userReducer.moduleFiles,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(TaskView)
